<template>
    <v-container
        class="fill-height"
        fluid
    >
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="4"
                sm="8"
            >
                <v-card
                    class="text-xs-center mt-8"
                    style="padding:30px;width:300px;height:320px;margin:auto;"
                >
                    <v-img
                        :src="ecsLogo"
                        class="mx-auto"
                        style="border-radius: 0"
                        width="80"
                    />
                    <h1
                        class="text-center black--text mt-4 mb-4 display-1 text-xs-center mx-auto"
                        style="font-family: 'Segoe UI', Frutiger, 'Frutiger Linotype', 'Dejavu Sans', 'Helvetica Neue', Arial, sans-serif!important;"
                    >
                        {{ systemName }}
                    </h1>
                    <v-btn
                        :style="{left: '50%', transform:'translateX(-50%)'}"
                        @click="logIn"
                        color="primary"
                        id="loginButton"
                    >Login
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import authentication from './../authentication'

    export default {
        name: 'Login',

        data: () => ({
            systemName: process.env.VUE_APP_SYSTEM_NAME,
            ecsLogo: require('@/assets/ECS_LOGO_GROUP.png'),
        }),

        methods: {
            logIn() {
                authentication.signIn();
            },
        },

    }
</script>

<style scoped>

</style>
